// // import React from 'react';
// // import { Button } from './ui/button';
// // import { ArrowRight } from 'lucide-react';
// // import { ctaSection } from '../mockData';

// // const CtaSection = () => {
// //   return (
// //     <section className="py-28 px-6 bg-gradient-to-b from-white via-gray-50 to-white">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center max-w-4xl mx-auto mb-16">
// //           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{ctaSection.title}</h2>
// //           <p className="text-xl text-gray-600 mb-10">{ctaSection.subtitle}</p>
// //           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-10 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
// //             {ctaSection.cta}
// //             <ArrowRight className="w-5 h-5 ml-2" />
// //           </Button>
// //           <p className="text-base text-gray-500 mt-8 font-medium">{ctaSection.bottomText}</p>
// //         </div>
// //         <div className="mt-20 rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
// //           <img src={ctaSection.image} alt="Platform" className="w-full hover:scale-105 transition-transform duration-700" />
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default CtaSection;


// //INI FIX SEBELUMNYA
// import React from 'react';
// import { Button } from '@/components/ui/button';
// import { ArrowRight } from 'lucide-react';
// import { ctaSection } from '@/mockData';

// const CtaSection = () => {
//   return (
//     // DIUBAH: Dihapus 'bg-gradient-to-b from-white via-gray-50 to-white'
//     <section className="py-28 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center max-w-4xl mx-auto mb-16">
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{ctaSection.title}</h2>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-xl text-gray-300 mb-10">{ctaSection.subtitle}</p>
//           {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
//           <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-10 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
//             {ctaSection.cta}
//             <ArrowRight className="w-5 h-5 ml-2" />
//           </Button>
//           {/* DIUBAH: Teks bawah diubah menjadi 'text-gray-400' */}
//           <p className="text-base text-gray-400 mt-8 font-medium">{ctaSection.bottomText}</p>
//         </div>
//         <div className="mt-20 rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
//           <img src={ctaSection.image} alt="Platform" className="w-full hover:scale-105 transition-transform duration-700" />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CtaSection;

import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { ctaSection } from '@/mockData';
import CardSwap, { Card } from '@/components/CardSwap'; // DIITAMBAHKAN
import '@/components/CardSwap.css'; // DIITAMBAHKAN

const CtaSection = () => {
  // Ini adalah URL gambar dari mockData Anda
  const cardImages = [
    "https://kontentutorialmpstore-cdn.maduraprime.com/ff965ca3-6ec3-4dac-964d-f98a71cca180.png",
    "https://kontentutorialmpstore-cdn.maduraprime.com/63ff1635-eaca-434d-922c-00159ec724c8.png",
    "https://kontentutorialmpstore-cdn.maduraprime.com/c0425831-996a-4f3b-97b5-9ae73406e005.png",
    "https://kontentutorialmpstore-cdn.maduraprime.com/324fab7a-d81b-41aa-8fa7-79a46f87580b.png",
    "https://kontentutorialmpstore-cdn.maduraprime.com/eded6c66-e120-41d7-905a-624f9bb87736.png"
  ];

  return (
    // DIUBAH: Dihapus 'bg-gradient-to-b from-white via-gray-50 to-white'
    // DIUBAH: Tambahkan overflow-hidden agar kartu yang "melebar" tidak menyebabkan scroll horizontal
    <section className="py-28 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">

        {/* --- BLOK INI DIUBAH TOTAL --- */}
        {/* Menggunakan grid 2-kolom untuk Teks di kiri dan Kartu di kanan */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* KOLOM 1: Teks */}
          {/* DIUBAH: Hapus 'text-center' dan 'mx-auto', tambahkan 'text-left' */}
          <div className="text-left max-w-lg">
            {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
            <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{ctaSection.title}</h2>
            {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
            <p className="text-xl text-gray-300 mb-10">{ctaSection.subtitle}</p>
            {/* Tombol ini (putih) sudah kontras dengan background gelap, jadi tidak diubah */}
            <Button className="bg-white text-black border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl px-10 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all">
              {ctaSection.cta}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            {/* DIUBAH: Teks bawah diubah menjadi 'text-gray-400' */}
            <p className="text-base text-gray-400 mt-8 font-medium">{ctaSection.bottomText}</p>
          </div>

          {/* KOLOM 2: CardSwap */}
          {/* Wrapper ini harus 'relative' dan punya 'height' agar CardSwap.css bisa bekerja */}
          <div className="relative lg:h-[500px] flex justify-center items-center py-12 lg:py-0">
            <CardSwap
              width={900} // Lebar kartu
              height={500} // Tinggi kartu
              cardDistance={60}
              verticalDistance={70}
              delay={5000}
              pauseOnHover={true}
              easing="power1" // 'power1' lebih halus dari 'elastic'
            >
              {/* Di sinilah Anda memasukkan gambar Anda.
                Saya menggunakan URL dari mockData sebagai contoh.
              */}
              <Card className="overflow-hidden border-gray-700/50 p-3">
                <img src={cardImages[0]} alt="Screenshot 1" className="w-full h-full object-cover rounded-lg" />
              </Card>
              <Card className="overflow-hidden border-gray-700/50 p-3">
                <img src={cardImages[1]} alt="Screenshot 2" className="w-full h-full object-cover rounded-lg" />
              </Card>
              <Card className="overflow-hidden border-gray-700/50 p-3">
                <img src={cardImages[2]} alt="Screenshot 3" className="w-full h-full object-cover rounded-lg" />
              </Card>
              <Card className="overflow-hidden border-gray-700/50 p-3">
                <img src={cardImages[3]} alt="Screenshot 4" className="w-full h-full object-cover rounded-lg" />
              </Card>
              <Card className="overflow-hidden border-gray-700/50 p-3">
                <img src={cardImages[4]} alt="Screenshot 5" className="w-full h-full object-cover rounded-lg" />
              </Card>
            </CardSwap>
          </div>

        </div>
        {/* --- AKHIR BLOK YANG DIUBAH --- */}

      </div>
    </section>
  );
};

export default CtaSection;